import { Layout as AntLayout, Space } from 'antd';
import { Header, SideBar } from 'components';
import { ResultError } from 'components/errors';
import { DashBoardApiService } from 'features/Dashboard/api/dashboard-api.service';
import { NotificationDocuments } from 'features/Dashboard/components/notification/notification-documents';
import { useSideBar } from 'providers/side-bar-provider';
import { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useParams } from 'react-router-dom';

import { StyledLayout } from './layout.styles';

export const Layout = () => {
  const { collapsed, notificationCollapsed } = useSideBar();
  const { Content } = AntLayout;
  const { id } = useParams();
  const [notification, SetNotification] = useState<any>(null);
  const initial = async () => {
    try {
      const apiRes = await DashBoardApiService().GetNotifications('' as any);
      SetNotification(apiRes);
    } catch (error) {
      console.error('Error fetchings client status graph:', error);
    }
  };
  useEffect(() => {
    initial();
  }, []);
  
return (
    <StyledLayout
      $collapsed={collapsed}
      $notificationCollapsed={notificationCollapsed}
    >
      <Header refetch={initial} />

      <AntLayout>
        <SideBar />
        <Content
          className={`layout-content main-panel ${id && 'mblvwmainpage'}`}
        >
          <ErrorBoundary FallbackComponent={ResultError}>
            <Space className='layout-space'>
              <Outlet />
            </Space>
          </ErrorBoundary>
        </Content>

        <NotificationDocuments notification={notification} refetch={initial} />
      </AntLayout>
    </StyledLayout>
  );
};
